import React from 'react';
import PropTypes from 'prop-types';
import { StyledIconPng } from './style';

const IconPng = props => {
  const Tabindex = props.hover ? '0' : '-1';
  const Role = props.hover ? 'button' : '';

  return (
    <StyledIconPng
      className={props.className}
      color={props.color}
      id={props.id}
      size={props.size}
      src={props.src}
      onClick={props.onClick}
      tabIndex={Tabindex}
      role={Role}
      expanded={props.expanded}
      haspopup={props.haspopup}
      hover={props.hover}
      width={props.width}
      height={props.height}
    />
  );
};

IconPng.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'dark',
    'grayDark',
    'grayDarker',
    'light',
    'error',
    'success',
    'warning',
    'info',
    'main'
  ]),
  hover: PropTypes.bool,
  size: PropTypes.oneOf(['xxs', 'xs', 's', 'sm', 'smm', 'm', 'l', 'xl']),
  src: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
};

IconPng.defaultProps = {
  color: 'dark',
  hover: false
};

export default IconPng;
